__turbopack_context__.v({
  "avatar": "index-module-less-module__4QaYAq__avatar",
  "codeBlockWrap": "index-module-less-module__4QaYAq__codeBlockWrap",
  "codeCopyBtn": "index-module-less-module__4QaYAq__codeCopyBtn",
  "codeCopyBtnCopied": "index-module-less-module__4QaYAq__codeCopyBtnCopied",
  "codeCopyBtnIcon": "index-module-less-module__4QaYAq__codeCopyBtnIcon",
  "commandCard": "index-module-less-module__4QaYAq__commandCard",
  "commandHighlights": "index-module-less-module__4QaYAq__commandHighlights",
  "ctaBtn": "index-module-less-module__4QaYAq__ctaBtn",
  "demoCard": "index-module-less-module__4QaYAq__demoCard",
  "demoCardLg": "index-module-less-module__4QaYAq__demoCardLg",
  "demoCardSm": "index-module-less-module__4QaYAq__demoCardSm",
  "demoCardSmRight": "index-module-less-module__4QaYAq__demoCardSmRight",
  "demoCards": "index-module-less-module__4QaYAq__demoCards",
  "demoPreview": "index-module-less-module__4QaYAq__demoPreview",
  "demoPreviewImage": "index-module-less-module__4QaYAq__demoPreviewImage",
  "demos": "index-module-less-module__4QaYAq__demos",
  "demosHeader": "index-module-less-module__4QaYAq__demosHeader",
  "faq": "index-module-less-module__4QaYAq__faq",
  "faqAnswer": "index-module-less-module__4QaYAq__faqAnswer",
  "faqAnswerWrap": "index-module-less-module__4QaYAq__faqAnswerWrap",
  "faqAnswerWrapOpen": "index-module-less-module__4QaYAq__faqAnswerWrapOpen",
  "faqDivider": "index-module-less-module__4QaYAq__faqDivider",
  "faqIcon": "index-module-less-module__4QaYAq__faqIcon",
  "faqIconOpen": "index-module-less-module__4QaYAq__faqIconOpen",
  "faqItem": "index-module-less-module__4QaYAq__faqItem",
  "faqList": "index-module-less-module__4QaYAq__faqList",
  "faqQuestion": "index-module-less-module__4QaYAq__faqQuestion",
  "featureCard": "index-module-less-module__4QaYAq__featureCard",
  "featureIconWrap": "index-module-less-module__4QaYAq__featureIconWrap",
  "features": "index-module-less-module__4QaYAq__features",
  "footer": "index-module-less-module__4QaYAq__footer",
  "hero": "index-module-less-module__4QaYAq__hero",
  "heroDesc": "index-module-less-module__4QaYAq__heroDesc",
  "heroDescLine": "index-module-less-module__4QaYAq__heroDescLine",
  "heroPill": "index-module-less-module__4QaYAq__heroPill",
  "heroPills": "index-module-less-module__4QaYAq__heroPills",
  "heroTitle": "index-module-less-module__4QaYAq__heroTitle",
  "logo": "index-module-less-module__4QaYAq__logo",
  "logoText": "index-module-less-module__4QaYAq__logoText",
  "markdownContent": "index-module-less-module__4QaYAq__markdownContent",
  "navInner": "index-module-less-module__4QaYAq__navInner",
  "navbar": "index-module-less-module__4QaYAq__navbar",
  "page": "index-module-less-module__4QaYAq__page",
  "quickStart": "index-module-less-module__4QaYAq__quickStart",
  "quoteClose": "index-module-less-module__4QaYAq__quoteClose",
  "quoteEnd": "index-module-less-module__4QaYAq__quoteEnd",
  "quoteOpen": "index-module-less-module__4QaYAq__quoteOpen",
  "readmeTabBtn": "index-module-less-module__4QaYAq__readmeTabBtn",
  "readmeTabBtnActive": "index-module-less-module__4QaYAq__readmeTabBtnActive",
  "readmeTabs": "index-module-less-module__4QaYAq__readmeTabs",
  "readmeTabsFloating": "index-module-less-module__4QaYAq__readmeTabsFloating",
  "readmeTabsFloatingWrap": "index-module-less-module__4QaYAq__readmeTabsFloatingWrap",
  "reveal-up": "index-module-less-module__4QaYAq__reveal-up",
  "reviewCard": "index-module-less-module__4QaYAq__reviewCard",
  "reviewCardWide": "index-module-less-module__4QaYAq__reviewCardWide",
  "reviewList": "index-module-less-module__4QaYAq__reviewList",
  "reviewer": "index-module-less-module__4QaYAq__reviewer",
  "sectionSubtitle": "index-module-less-module__4QaYAq__sectionSubtitle",
  "sectionTitle": "index-module-less-module__4QaYAq__sectionTitle",
  "terminalBox": "index-module-less-module__4QaYAq__terminalBox",
  "testimonials": "index-module-less-module__4QaYAq__testimonials",
});
